module.exports = __webpack_public_path__ + "static/media/swift.118faace.png";